import { Component, OnInit } from '@angular/core';
import { gsap, Power2, ScrollTrigger } from 'gsap/all';

@Component({
  selector: 'app-testimonials',
  templateUrl: './testimonials.component.html',
  styleUrls: ['./testimonials.component.scss']
})
export class TestimonialsComponent implements OnInit {

  design:any =  {
    heading: "Design consulting",
    description: "We know every project presents its own unique set of circumstances. We strive to eliminate all the design hurdles for you and provide you with an all new living & working space by incorporating the design concepts you desire",
    image: "https://i.postimg.cc/25TxNMXg/arh-14.jpg",
    link: ""
  }

  construction:any =  {
    heading: "Construction consulting",
    description: "In the pursuit of effective use of space, user well-being, and functional design, the profession of home design intact with lifestyle was born. Bricks & Beams have been committed to creating tasteful homes & commercials spaces since 1989",
    image: "https://i.postimg.cc/fRRg8TgT/Screenshot-2021-04-06-at-7-17-47-PM.png",
    link: ""
  }

  ngOnInit(): void {
  }


  ngOnDestroy() {
  }
}
